/**
 * theme → legacy bridge: supply baseColors-shaped scale objects for the ACTIVE brand.
 *
 * RUNTIME USES BAKED DATA (theme/generated/activeBrandScales.js), NOT the OKLCH generator — culori
 * ships a browser-global IIFE build that CRA's webpack loads for require(), which breaks the runtime
 * import. Baking keeps culori out of the app bundles entirely. The generator (generate.js) runs only
 * in Node, for the bake script (scripts/bakeScales.js) and the tests.
 *
 * One brand per build: `switch <brand>` re-bakes generated/activeBrandScales.js from that brand's
 * configs/_shared colors, so there is exactly one active brand's scales here at any time. ACTIVE_META
 * carries the brand's non-scale styling (hero style/accent) through to assembly (themes.js).
 */
import { BASE_COLORS_LIGHT, BASE_COLORS_DARK } from './baseColors';
import { ACTIVE_LIGHT, ACTIVE_DARK, ACTIVE_META } from './generated/activeBrandScales';

export { ACTIVE_META };

/**
 * Build one mode's full family→scale map: baseColors overlaid with the active brand's baked OKLCH
 * families (blue/orange/gray/green/red/yellow/purple/emerald/indigo/pink/gold).
 * @param {'light'|'dark'} mode
 * @returns {Object} baseColors-shaped object (11 baked families, rest pass-through)
 */
export function getBaseScales(mode) {
  const base = mode === 'light' ? BASE_COLORS_LIGHT : BASE_COLORS_DARK;
  return { ...base, ...(mode === 'light' ? ACTIVE_LIGHT : ACTIVE_DARK) };
}
